//------------------------------------------------------------------------
// Mobile nav toggle
//------------------------------------------------------------------------
import ExpandToggle from '@threespot/expand-toggle';

export default class mobileNavToggle {
  constructor(el) {
    this.el = el;
    this.resetEvent = new CustomEvent('nav-reset');// used to close subnav menus

    // Nav breakpoint should match $layout-nav-bp in _layout-vars.scss
    this.mediaQueryList = window.matchMedia("(min-width: 1095px)");

    // Listen for breakpoint change
    this.mediaQueryList.addListener(evt => {
      // Emit “nav-reset” event to trigger subnav menus to collapse
      document.documentElement.dispatchEvent(this.resetEvent);

      if (evt.matches) {
        this.destroy();
      } else {
        this.init();
      }
    });

    // Init on load
    if (!this.mediaQueryList.matches) {
      this.init();
    }
  }

  subnavToggleHandler() {
    this.navToggle.updateExpandedHeight();
  }

  init() {
    this.navToggle = new ExpandToggle(this.el);

    // Update height when submennu is toggled
    document.documentElement.addEventListener('subnav-toggle', this.subnavToggleHandler.bind(this));
  }

  destroy() {
    this.navToggle.destroy();
    window.removeEventListener('subnav-toggle', this.subnavToggleHandler);
  }
}

// Init
const moblieToggle = document.querySelector('[data-expands="nav"]');

if (moblieToggle) {
  new mobileNavToggle(moblieToggle);
}